import {app} from '../../../../app';
import {Controller} from './authentication-access-policies.controller';

app.component('companyPoliciesAuthenticationAccessPolicies', {
    bindings: {
        companyId: '<',
        defaultPolicy: '<',
        policies: '<',
    },
    controller: Controller,
    templateUrl: require('./authentication-access-policies.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/policies/authentication-access-policies/authentication-access-policies.component.js